import { fetchPaymentMadeList } from '../../../../services/payment_made';
import { getDate } from '../../../../utils/dateUtils';
import { numberToWords } from '../../../../utils/helper';
import { generatePdfComponent } from '../../../components/generatePdfComponent';

export const generatePaymentMadePdf = async (ids) => {
	const paymentMades = await fetchPaymentMadeList({
		filterBy: 'payment_made_id',
		filterValue: JSON.stringify(ids),
	});
	const docDefinitions = [];
	paymentMades?.data.forEach((pm) => {
		const {
			vendor,
			organisation,
			payment_number,
			date,
			reference_number,
			payment_mode,
			payment_amount,
			purchase_bill_payment_made,
		} = pm;
		const productsPerPage = 8;

		const productChunks = [];
		for (let i = 0; i < purchase_bill_payment_made.length; i += productsPerPage) {
			productChunks.push(purchase_bill_payment_made.slice(i, i + productsPerPage));
		}
		productChunks.forEach((chunk, chunkIndex) => {
			const isLastChunk = chunkIndex === productChunks.length - 1;

			docDefinitions.push(
				generatePdfComponent({
					invoice_type: 'PAYMENT MADE',
					gst_number: `${organisation?.gst || 'N/A'}`,
					dl_number: `${organisation?.drug_license_number || 'N/A'}`,
					payment_method_section: [
						{
							value: `Paid Through : ${organisation.organisation_name}`,
							bold: false,
							margin: 10,
						},
						{
							value: payment_mode,
							bold: false,
							margin: 20,
						},
					],
					user2: {
						name: vendor.vendor_name,
						address: vendor?.vendor_address?.street_1 || 'N/A',
						city: vendor?.vendor_address?.city?.name || 'N/A',
						state: vendor?.vendor_address?.state?.name || 'N/A',
						country: vendor?.vendor_address?.country?.name || 'N/A',
						zip_code: vendor?.vendor_address?.zip_code || 'N/A',
						mobile: vendor?.phone_mobile || 'N/A',
						phone: vendor?.phone_landline || 'N/A',
						email: vendor?.email || 'N/A',
					},
					user1: {
						name: organisation.organisation_name,
						address: organisation?.address?.street_1 || 'N/A',
						city: organisation?.address?.city?.name || 'N/A',
						state: organisation?.address?.state?.name || 'N/A',
						country: organisation?.address?.country?.name || 'N/A',
						zip_code: organisation?.address?.postal_code || 'N/A',
						email: '',
						phone: '',
					},

					invoice_detail: [
						{ value: `Payment # : ${payment_number}`, bold: false },
						{ value: `Payment Date : ${getDate(date)}`, bold: false },
						{ value: `Reference Number : ${reference_number || 'N/A'}`, bold: false },
						{
							value: `Amount paid in words : ${numberToWords(Number(payment_amount))}`,
							bold: false,
						},
					],

					table_columns: [
						{
							label: 'Bill Number',
							key: 'bill_number',
							type: 'text',
							tableColWidth: '25%',
						},
						{
							label: 'Bill Date',
							key: 'bill_date',
							type: 'date',
							tableColWidth: '25%',
						},
						{
							label: 'Bill Amount',
							key: 'bill_amount',
							type: 'number',
							tableColWidth: '25%',
						},
						{
							label: 'Payment Amount',
							key: 'payment_amount',
							type: 'number',
							tableColWidth: '25%',
						},
					],

					table_body_data: chunk.map((data, index) => ({
						bill_number: data.purchase_bill?.bill_number,
						bill_date: data.purchase_bill?.bill_date,
						bill_amount: data.purchase_bill?.bill_amount,
						payment_amount: data.payment_amount,
					})),
					taxCalculation: null,
					footer_table_columns: [],
					footer_table_data: [],
					notes: '',
					isLastChunk: isLastChunk,
				}),
			);
		});
	});

	let mergedContent = [];
	docDefinitions.forEach((doc, index) => {
		mergedContent = mergedContent.concat(doc.content);

		if ((index + 1) % 2 === 0) {
			mergedContent.push({ text: '', pageBreak: 'after' });
		}
	});

	const mergedDocDefinition = {
		pageSize: 'A5',
		pageMargins: [5, 5, 5, 5],
		content: mergedContent,
	};

	return mergedDocDefinition;
};
